import React, { useContext, useEffect, useState } from "react";
import { apiGet, apiDelete, apiPut} from "../../utils/apiFetch";
import apiPath from "../../utils/pathObj";
import OButton from "components/reusable/OButton";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import dayjs from "dayjs";
import Pagination from "../Pagination";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import EmployeeTaskList from "./EmployeeTaskList";
import EmployeeTaskAdd from "./EmployeeTaskAdd";
import EmployeeTaskEdit from "./EmployeeTaskEdit";
import EmployeeTaskView from "./EmployeeTaskView";
import ReassignTask from "./ReassignTask";
import NoteView from "./NoteView";
import helpers from "utils/helpers";
import OSearch from "components/reusable/OSearch";

const EmployeeTaskScheduling = () => {
  const { updatePageName } = useContext(AuthContext);
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [taskList, setTaskList] = useState([]);
  const [employeeTaskAdd, setEmployeeTaskAdd] = useState(false);
  const [employeeTaskEdit, setEmployeeTaskEdit] = useState(false);
  const [currentItem, setCurrentItem] = useState("");
  const [employeeTaskView, setEmployeeTaskView] = useState(false);
  const [employeeTaskReassign, setEmployeeTaskReassign] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [noteView, setNoteView] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const [filterData, setFilterData] = useState({
    category: "",
    tagsCategory: "",
    stateCategory: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sortBy: "createdAt",
    sortType: "desc",
  });

  const handleEdit = (item) => {
    setCurrentItem(item);
    setEmployeeTaskEdit(!employeeTaskEdit);
  };

  const handleView = (item) => {
    setCurrentItem(item);
    setEmployeeTaskView(!employeeTaskView);
  };
  

  const handleNoteView = (item) => {
    setCurrentItem(item);
    setNoteView(!noteView);
    setSelectedTask(item);
  };

  const handleCategory = () => {
    setEmployeeTaskAdd(!employeeTaskAdd);
  };
  const handleTask = (item) => {
    setCurrentItem(item);
    setEmployeeTaskReassign(!employeeTaskReassign);
  };

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const allTaskScheduling = async (data) => {
    try {
      const { category, tagsCategory, startDate, endDate, searchKey, isFilter, stateCategory } = filterData;
      if ((data?.deletePage && taskList?.length >= 1) || (isFilter && category && tagsCategory && stateCategory && data?.statusChange && taskList?.length >= 1)) {
        setPage(page - 1);
        setPaginationObj({ ...paginationObj, page: page - 1 });
      }

      const payload = {
        page,
        pageSize,
        status: category,
        tags: tagsCategory,
        state: stateCategory,
        startDate: helpers.ternaryCondition(startDate, dayjs(startDate).format("YYYY-MM-DD"), null),
        endDate: helpers.ternaryCondition(endDate, dayjs(endDate).format("YYYY-MM-DD"), null),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType,
      };
      const path = apiPath.allTaskSchedulingList;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setTaskList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: helpers.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers.ternaryCondition(resultStatus, response.totalPages, null),
        perPageItem: helpers.ternaryCondition(resultStatus, response?.docs.length, null),
        totalItems: helpers.ternaryCondition(resultStatus, response.totalDocs, null),
      });
    } catch (error) {
      console.log("error in get all country list==>>>>", error.message);
    }
  };

  useEffect(() => {
    allTaskScheduling();
  }, [page, filterData, sort]);

  const handleDelete = async (taskId) => {
    try {
      await apiDelete(`${apiPath.taskDelete}/${taskId}`);
      allTaskScheduling({ deletePage: true }); // Refresh the list after deletion
    } catch (error) {
      console.log("Delete error:", error);
    }
  };

  const handleCancel = async (taskId) => {
    try {
      await apiPut(`${apiPath.cancelTask}/${taskId}`);
      allTaskScheduling({ deletePage: true }); // Refresh the list after deletion
    } catch (error) {
      console.log("Cancel error:", error);
    }
  };  

  const handleReset = () => {
    setFilterData({
      category: "",
      tagsCategory: "",
      stateCategory: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTerm("");
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };
  const statusPage = (e) => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true });
    setPage(1);
  };
  const statePage = (e) => {
    setFilterData({ ...filterData, stateCategory: e.target.value, isFilter: true });
    setPage(1);
  };
  const tagsPage = (e) => {
    setFilterData({
      ...filterData,
      tagsCategory: e.target.value,
      isFilter: true,
    });
    setPage(1);
  };

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    updatePageName(t("EMPLOYEE_TASKS_SCHEDULING"));
  }, []);

  return (
    <>
      {" "}
      <div className="bg-[#F9F9F9]">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] rounded-lg">
            <form className="border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3">
              <div className="col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0">
                <div className="flex items-center lg:pt-0 pt-3 flex-wrap ">
                  <div className="relative flex items-center mb-3">
                    <OSearch searchTerm={searchTerm} placeholder={t("SEARCH_BY_NAME_TASK")} setSearchTerm={setSearchTerm} />
                  </div>
                  <ODateRangePicker taskStartDate taskEndDate handleDateChange={handleDateChange} isReset={filterData?.isReset} setIsReset={setFilterData} />
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      id=""
                      type="text "
                      name="tags"
                      className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      onChange={(e) => tagsPage(e)}
                      value={filterData?.tagsCategory}
                    >
                      <option value="">
                        {t("TAGS")}
                      </option>
                      <option key="assigned" value="assigned">{t("ASSIGNED")}</option>
                      <option key="reAssigned" value="reAssigned">{t("REASSIGNED")}</option>
                      <option key="collaborated" value="collaborated">{t("COLLABORATED")}</option>
                    </select>
                  </div>
                  <div className="flex items-center ml-3 mb-3">
                    <select
                      type="text "
                      onChange={(e) => statusPage(e)}
                      id=""
                      value={filterData?.category}
                      name="status"
                      className="dark:text-white block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                    >
                      <option value="">
                        {t("STATUS")}
                      </option>
                      <option key="accepted" value="accepted">{t("ACCEPTED")}</option>
                      <option key="rejected" value="rejected">{t("REJECTED")}</option>
                      <option key="requested" value="requested">{t("REQUESTED")}</option>
                      <option key="canceled" value="canceled">{t("CANCELED")}</option>
                    </select>
                  </div>
                  <div className="flex items-center  ml-3 mb-3">
                    <select
                      type="text "
                      onChange={(e) => statePage(e)}
                      id=""
                      value={filterData?.stateCategory}
                      name="state"
                      className="dark:text-white block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                    >
                      <option value="">
                        {t("STATE")}
                      </option>
                      <option key="notStarted" value="notStarted">{t("NOT_STARTED")}</option>
                      <option key="working" value="working">{t("WORKING")}</option>
                      <option key="done" value="done">{t("DONE")}</option>
                      <option key="notCompleted" value="notCompleted">{t("NOT_COMPLETED")}</option>
                    </select>
                  </div>

                  <OButton onClick={handleReset} extraClasses="mb-3 ml-3 " label="Reset" type="button" style={{ borderRadius: "0.5rem" }} />
                </div>
              </div>
              <div className="flex items-center justify-end px-4 ms-auto mb-3">
                <button title={t("ASSIGN_TASK")} type="button" className="bg-LightBlue flex text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue whitespace-nowrap" onClick={() => handleCategory()}>
                  + {t("ASSIGN_TASK")}
                </button>
              </div>
            </form>
            <EmployeeTaskList
              taskList={taskList}
              setTaskList={setTaskList}
              allTaskScheduling={allTaskScheduling}
              page={page}
              handleEdit={handleEdit}
              handleView={handleView}
              handleTask={handleTask}
              handleNoteView={handleNoteView}
              handleDelete={handleDelete}
              handleCancel={handleCancel}
              currentItem={currentItem}
              employeeTaskView={employeeTaskView}
              setSort={setSort}
              sort={sort}
            />
            {employeeTaskView && <EmployeeTaskView employeeTaskView={employeeTaskView} currentItem={currentItem} handleView={handleView} allTaskScheduling={allTaskScheduling} />}

            {employeeTaskEdit && <EmployeeTaskEdit handleEdit={handleEdit} currentItem={currentItem} allTaskScheduling={allTaskScheduling} />}

            {helpers.ternaryCondition(employeeTaskAdd, <EmployeeTaskAdd allTaskScheduling={allTaskScheduling} employeeTaskAdd={employeeTaskAdd} handleCategory={handleCategory} setPage={setPage} />, null)}
            {employeeTaskReassign ? <ReassignTask allTaskScheduling={allTaskScheduling} employeeTaskReassign={employeeTaskReassign} handleTask={handleTask} currentItem={currentItem} /> : null}
            {helpers.ternaryCondition(paginationObj?.totalItems, <Pagination handlePageClick={handlePageClick} options={paginationObj} page={page} />, null)}

            {noteView && <NoteView noteView={noteView} selectedTask={selectedTask} currentItem={currentItem} handleNoteView={handleNoteView} allTaskScheduling={allTaskScheduling} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeTaskScheduling;
